import React, { useState } from "react";
import "./register.css";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase";
import { setDoc, doc, Timestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    error: null,
    loading: false,
  });

  let navigate = useNavigate();

  const { name, email, password, error, loading } = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true });
    if (!name || !email || !password) {
      setData({ ...data, error: "All fields are required" });
    }
    try {
      const result = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      await setDoc(doc(db, "users", result.user.uid), {
        uid: result.user.uid,
        name,
        email,
        createdAt: Timestamp.fromDate(new Date()),
        isOnline: true,
      });
      setData({
        name: "",
        email: "",
        password: "",
        error: null,
        loading: false,
      });
      navigate("/");
    } catch (err) {
      setData({ ...data, error: err.message, loading: false });
    }
  };

  return (
    <div className="register">
      <div className="register-form">
        <h1>Create Your MessageUp Account</h1>

        <form onSubmit={handleSubmit}>
          <label>Name</label>
          <br />
          <input
            name="name"
            type="text"
            value={name}
            onChange={handleChange}
            placeholder="Name or Nickname"
          />
          <br />
          <label>Email</label>
          <br />
          <input
            name="email"
            type="email"
            value={email}
            onChange={handleChange}
            placeholder="Example@email.com"
          />
          <br />
          <label>Password</label>
          <br />
          <input
            name="password"
            type="password"
            value={password}
            onChange={handleChange}
            placeholder="Enter Password"
          />
          <br />
          {error ? <p className="error">{error}</p> : null}
          <button className="submit-btn" disabled={loading} type="Submit">
            {loading ? "Creating ..." : "Register"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
